<template>
  <div class="modal animated is-active">
    <div class="modal-background"></div>
    <div class="modal-card is-large">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ title }}</p>
      </header>
      <section class="modal-card-body">
        <div class="notification is-danger" v-if="error !== ''">{{ error }}</div>
        <div class="control is-vertical">
          <div class="control is-grouped">
            <p class="control is-expanded">
              <label class="label">SWIFT</label>
              <input class="input" type="text" name="swift" id="swift" placeholder="SWIFT" v-model="bank.SWIFT">
            </p>
            <p class="control is-expanded">
              <label class="label">Code</label>
              <input class="input" type="text" name="code" id="code" placeholder="Code" v-model="bank.code">
            </p>
            <p class="control is-expanded">
              <label class="label">Currerncy</label>
              <select class="select is-fullwidth" v-model="bank.currency" name="currency" id="currency">
                <option value="BRL">BRL</option>
                <option value="USD">USD</option>
                <option value="EUR">EUR</option>
                <option value="AUD">AUD</option>
                <option value="CAD">CAD</option>
                <option value="MXN">MXN</option>
                <option value="GBP">GBP</option>
                <option value="ARS">ARS</option>
                <option value="ZAR">ZAR</option>
                <option value="THB">THB</option>
                <option value="AED">AED</option>
                <option value="IDR">IDR</option>
                <option value="MOP">MOP</option>
                <option value="KRW">KRW</option>
                <option value="THB">THB</option>
                <option value="PHP">PHP</option>
                <option value="MYR">MYR</option>
                <option value="DKK">DKK</option>
                <option value="CHF">CHF</option>
                <option value="DZD">DZD</option>
                <option value="MAD">MAD</option>
                <option value="KZT">KZT</option>
                <option value="RUB">RUB</option>
                <option value="SEK">SEK</option>
                <option value="NZD">NZD</option>
                <option value="PLN">PLN</option>
                <option value="HKD">HKD</option>
                <option value="CNY">CNY</option>
                <option value="JPY">JPY</option>
                <option value="AMD">AMD</option>
                <option value="INR">INR</option>
                <option value="COP">COP</option>
              </select>
            </p>
          </div>
        </div>
        <p class="control">
          <label class="label">Bank Name</label>
          <input class="input" type="text" name="name" id="name" placeholder="Name" v-model="bank.bank_name">
        </p>
        <p class="control">
          <label class="label">Provider Name</label>
          <input class="input" type="text" name="provider_name" id="provider_name" placeholder="" v-model="bank.provider_name">
        </p>
        <p class="control is-expanded">
          <label class="label">Address</label>
          <input class="input" type="text" name="address" id="address" placeholder="Address" v-model="bank.address">
        </p>
        <div class="control is-vertical">
          <div class="control is-grouped">
            <p class="control is-expanded">
              <label class="label">City</label>
              <input class="input" type="text" name="city" id="city" placeholder="City" v-model="bank.city">
            </p>
            <p class="control is-expanded">
              <label class="label">Country</label>
              <input class="input" type="text" name="country" id="country" placeholder="Country" v-model="bank.country">
            </p>
          </div>
        </div>
        <div class="control is-vertical">
          <div class="control is-grouped">
            <p class="control is-expanded">
              <label class="label">IBAN</label>
              <input class="input" type="text" name="iban" id="iban" placeholder="IBAN" v-model="bank.iban">
            </p>
            <p class="control is-expanded">
              <label class="label">Account</label>
              <input class="input" type="text" name="account" id="account" placeholder="Account" v-model="bank.account">
            </p>
          </div>
        </div>
        <p class="control is-expanded">
          <label class="label">Routing Number</label>
          <input class="input" type="text" name="routing_number" id="routing_number" placeholder="" v-model="bank.routing_number">
        </p>
        <p class="control is-expanded">
          <label class="label">Observation</label>
          <input class="input" type="text" name="observation" id="observation" placeholder="" v-model="bank.obs">
        </p>
        <p style="color: red; margin-top: 10px; margin-bottom: 10px;"><b>Intermediary Bank</b></p>
        <div class="control is-vertical">
          <div class="control is-grouped">
            <p class="control is-expanded">
              <label class="label">SWIFT</label>
              <input class="input" type="text" name="swift" id="swift" placeholder="SWIFT" v-model="bank.SWIFT_intermediate">
            </p>
            <p class="control is-expanded">
              <label class="label">Code</label>
              <input class="input" type="text" name="code" id="code" placeholder="Code" v-model="bank.code_intermediate">
            </p>
            <p class="control is-expanded">
              <label class="label">Currerncy</label>
              <select class="select is-fullwidth" v-model="bank.currency_intermediate" name="currency_intermediate" id="currency_intermediate">
                <option value="BRL">BRL</option>
                <option value="USD">USD</option>
                <option value="EUR">EUR</option>
                <option value="AUD">AUD</option>
                <option value="CAD">CAD</option>
                <option value="MXN">MXN</option>
                <option value="GBP">GBP</option>
                <option value="ARS">ARS</option>
                <option value="ZAR">ZAR</option>
                <option value="THB">THB</option>
                <option value="AED">AED</option>
                <option value="IDR">IDR</option>
                <option value="MOP">MOP</option>
                <option value="KRW">KRW</option>
                <option value="THB">THB</option>
                <option value="PHP">PHP</option>
                <option value="MYR">MYR</option>
                <option value="DKK">DKK</option>
                <option value="CHF">CHF</option>
                <option value="DZD">DZD</option>
                <option value="MAD">MAD</option>
                <option value="KZT">KZT</option>
                <option value="RUB">RUB</option>
                <option value="SEK">SEK</option>
                <option value="NZD">NZD</option>
                <option value="PLN">PLN</option>
                <option value="HKD">HKD</option>
                <option value="CNY">CNY</option>
                <option value="JPY">JPY</option>
                <option value="AMD">AMD</option>
                <option value="INR">INR</option>
                <option value="COP">COP</option>
              </select>
            </p>
          </div>
        </div>
        <p class="control">
          <label class="label">Bank Name</label>
          <input class="input" type="text" name="name" id="name" placeholder="Name" v-model="bank.bank_name_intermediate">
        </p>
        <p class="control">
          <label class="label">Provider Name</label>
          <input class="input" type="text" name="provider_name_intermediate" id="provider_name_intermediate" placeholder="" v-model="bank.provider_name_intermediate">
        </p>
        <p class="control is-expanded">
          <label class="label">Address</label>
          <input class="input" type="text" name="address" id="address" placeholder="Address" v-model="bank.address_intermediate">
        </p>
        <div class="control is-vertical">
          <div class="control is-grouped">
            <p class="control is-expanded">
              <label class="label">City</label>
              <input class="input" type="text" name="city" id="city" placeholder="City" v-model="bank.city_intermediate">
            </p>
            <p class="control is-expanded">
              <label class="label">Country</label>
              <input class="input" type="text" name="country" id="country" placeholder="Country" v-model="bank.country_intermediate">
            </p>
          </div>
        </div>
        <div class="control is-vertical">
          <div class="control is-grouped">
            <p class="control is-expanded">
              <label class="label">IBAN</label>
              <input class="input" type="text" name="iban" id="iban" placeholder="IBAN" v-model="bank.iban_intermediate">
            </p>
            <p class="control is-expanded">
              <label class="label">Account</label>
              <input class="input" type="text" name="account" id="account" placeholder="Account" v-model="bank.account_intermediate">
            </p>
          </div>
        </div>
        <p class="control is-expanded">
          <label class="label">Routing Number</label>
          <input class="input" type="text" name="routing_number_intermediate" id="routing_number_intermediate" placeholder="" v-model="bank.routing_number_intermediate">
        </p>
        <p class="control is-expanded">
          <label class="label">Observation</label>
          <input class="input" type="text" name="observation_intermediate" id="observation_intermediate" placeholder="" v-model="bank.obs_intermediate">
        </p>
      </section>
      <footer class="modal-card-foot">
        <div class="control is-grouped is-pulled-right">
          <p class="control is-pulled-right">
            <a :class="{'button': true, 'is-primary': true, 'is-disabled': inProgress}" @click="close(true)">Close</a>
          </p>
          <p class="control">
            <a :class="{'button': true, 'is-success': true, 'is-loading': inProgress}" @click="save">Save</a>
          </p>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      context: {
        type: Object
      },
      callback: {
        type: String
      },
      title: {
        type: String
      },
      id: {
        type: Number
      },
      provider_id: {
        type: Number
      },
      parent: {
        type: Object
      }
    },
    data () {
      return {
        bank: {
          bank_name: '',
          city: '',
          country: '',
          address: ''
        },
        inProgress: false,
        error: ''
      }
    },
    mounted () {
      this.$nextTick(() => {
        this.loadData()
      })
    },
    methods: {
      close (closeOnly, result) {
        if (!closeOnly) {
          this.parent[this.callback](result)
        }
        this.$el.remove()
      },
      save () {
        // if (this.$validator.errorBag.errors.length === 0) {
        this.inProgress = true
        this.error = ''
        if (this.id) {
          this.context.$http.post(this.context.$store.state.config.apiURL + '/providers/bank_data/' + this.id, this.bank).then((response) => {
            this.inProgress = false
            this.close(false, {ok: true, message: 'The bank ' + response.body.bank_name + ' was successfully save'})
          }, (response) => {
            this.inProgress = false
            this.error = response.body
          })
        } else {
          this.context.$http.post(this.context.$store.state.config.apiURL + '/providers/bank_data', this.bank).then((response) => {
            this.inProgress = false
            this.close(false, {ok: true, message: 'The bank ' + response.body.bank_name + ' was successfully save'})
          }, (response) => {
            this.inProgress = false
            this.error = response.body
          })
        }
      },
      loadData () {
        if (this.id) {
          this.context.$http.get(this.context.$store.state.config.apiURL + '/providers/bank_data/' + this.id).then((response) => {
            this.bank = response.body
            document.body.appendChild(this.$el)
          }, (response) => {
          })
        } else {
          this.bank.provider_id = this.provider_id
          document.body.appendChild(this.$el)
        }
      }
    },
    computed: {
      enterClass () {
        return `${this.transition}In`
      },
      leaveClass () {
        return `${this.transition}Out`
      }
    }
  }
</script>
<style lang="scss" scoped>
  .is-title {
    text-transform: capitalize;
  }

  .panel {
    background-color: white;
    box-shadow: 0px 2px 3px rgb(167, 28, 32), 0px 0px 0px 1px rgb(167, 28, 32);
    color: #4a4a4a;
    max-width: 100%;
    position: relative;
    border: 0px;
    border-radius: 0px;
  }

  .panel-heading {
    color: #FFFFFF;
    font-weight: bold;
    -ms-flex-align: stretch;
    align-items: stretch;
    display: -ms-flexbox;
    display: flex;
    min-height: 40px;
    box-shadow: 0px 1px 0px rgb(167, 28, 32), 0px 0px 0px 0px rgb(167, 28, 32);
    background-color: rgb(167, 28, 32);
    border-bottom: 0px;
    border-radius: 0px;
    font-size: 1rem;
  }
</style>



// WEBPACK FOOTER //
// ProviderBankData.vue?0d79b622